import { BrowserRouter, Route, Routes } from 'react-router-dom';
import React from 'react';
import { ProtectedRoute } from './ProtectedRoute';
import { USER_ROLES } from '../CurrentUserProvider/CurrentUserContext';
import { CustomLoader } from '../../loader/CustomLoader';
import styled from 'styled-components';

export const PageRoutes = {
	ROOT: '/',
	MEMBER_REGISTRATION: '/member-register',
	MEMBER_REGISTRATION_CORRECTION: '/member-registration-correction',
	MEMBER_SEARCH: '/admin',
	LOGIN: '/login',
	ATTENDANCE: '/attendance',
	FILES: '/uploadFile',
};

const Attendance = React.lazy(() => import('../../../layouts/Attendance'));
const HomeScreen = React.lazy(() => import('../../../layouts/HomeScreen'));
const MemberRegistration = React.lazy(() => import('../../../layouts/MemberRegistration'));
const MemberUpdate = React.lazy(() => import('../../../layouts/MemberUpdate'));
const MemberDataGridContainer = React.lazy(() => import('../../../layouts/MemberDataGrid'));
const Files = React.lazy(() => import('../../../layouts/Files'));
const Login = React.lazy(() => import('../../../layouts/Login'));
const ErrorPage = React.lazy(() => import('../../../layouts/ErrorPage'));

export const RouteProvider = (): JSX.Element | null => {
	return (
		<BrowserRouter basename="/reg">
			<Routes>
				<Route
					path={PageRoutes.ROOT}
					element={
						<React.Suspense
							fallback={
								<StyledPageContainer>
									<CustomLoader />
								</StyledPageContainer>
							}>
							<HomeScreen />
						</React.Suspense>
					}
				/>
				<Route
					path={PageRoutes.MEMBER_REGISTRATION}
					element={
						<React.Suspense
							fallback={
								<StyledPageContainer>
									<CustomLoader />{' '}
								</StyledPageContainer>
							}>
							<MemberRegistration />
						</React.Suspense>
					}
				/>
				<Route
					path={PageRoutes.LOGIN}
					element={
						<React.Suspense
							fallback={
								<StyledPageContainer>
									<CustomLoader />
								</StyledPageContainer>
							}>
							<Login />
						</React.Suspense>
					}
				/>
				<Route
					path={`${PageRoutes.MEMBER_REGISTRATION_CORRECTION}/:id`}
					element={
						<ProtectedRoute requiredRole={USER_ROLES.ADMIN}>
							<React.Suspense
								fallback={
									<StyledPageContainer>
										<CustomLoader />
									</StyledPageContainer>
								}>
								<MemberUpdate />
							</React.Suspense>
						</ProtectedRoute>
					}
				/>
				<Route
					path={PageRoutes.MEMBER_SEARCH}
					element={
						<ProtectedRoute requiredRole={USER_ROLES.ADMIN}>
							<React.Suspense
								fallback={
									<StyledPageContainer>
										<CustomLoader />
									</StyledPageContainer>
								}>
								<MemberDataGridContainer />
							</React.Suspense>
						</ProtectedRoute>
					}
				/>
				<Route
					path={PageRoutes.ATTENDANCE}
					element={
						<ProtectedRoute requiredRole={USER_ROLES.COORDINATOR}>
							<React.Suspense
								fallback={
									<StyledPageContainer>
										<CustomLoader />
									</StyledPageContainer>
								}>
								<Attendance />
							</React.Suspense>
						</ProtectedRoute>
					}
				/>
				<Route
					path={PageRoutes.FILES}
					element={
						<ProtectedRoute requiredRole={USER_ROLES.ADMIN}>
							<React.Suspense
								fallback={
									<StyledPageContainer>
										<CustomLoader />
									</StyledPageContainer>
								}>
								<Files />
							</React.Suspense>
						</ProtectedRoute>
					}
				/>
				<Route
					path="*"
					element={
						<React.Suspense
							fallback={
								<StyledPageContainer>
									<CustomLoader />
								</StyledPageContainer>
							}>
							<ErrorPage />
						</React.Suspense>
					}
				/>
			</Routes>
		</BrowserRouter>
	);
};

const StyledPageContainer = styled.div`
	height: 100vh !important;
`;
